export function renderSingleRelationshipFieldActionButtonsTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  toPascalCase,
  dataArray,
  displayField,
  toLowerCase,
  relSingular,
  secondaryDisplayField,
  defaultValueFromHandlerContent
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  toPascalCase: string
  dataArray: string
  displayField: string
  toLowerCase: string
  relSingular: string
  secondaryDisplayField: string
  defaultValueFromHandlerContent: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <Popover open={${fieldName}Open} onOpenChange={set${toPascalCase}Open}>
${indent}        <PopoverTrigger
${indent}          render={
${indent}            <FormControl>
${indent}              <Button
${indent}              variant="outline"
${indent}              role="combobox"
${indent}              className={cn("w-full justify-between", {
${indent}                "text-muted-foreground": !formField.value
${indent}              })}
${indent}              disabled={isPending}
${indent}              >
${indent}              {formField.value
${indent}                ? (() => {
${indent}                    const item = ${dataArray}?.find((item) => item.id !== null && String(item.id) === formField.value)
${indent}                    return item ? (${displayField}) : "Select ${toLowerCase}"
${indent}                  })()
${indent}                : "Select ${toLowerCase}"}
${indent}                <ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />
${indent}              </Button>
${indent}            </FormControl>
${indent}          }
${indent}        />
${indent}        <PopoverContent className="w-full p-0" align="start">
${indent}          <Command>
${indent}            <CommandInput placeholder="Search ${toLowerCase}..." />
${indent}            <CommandList>
${indent}              <CommandEmpty>No ${relSingular} found.</CommandEmpty>
${indent}              <CommandGroup>
${indent}                {${dataArray}?.filter((item) => item.id !== null).map((item) => {
${indent}                  const displayName = ${displayField}
${indent}                  const secondaryDisplayName = ${secondaryDisplayField}
${indent}                  return (
${indent}                    <CommandItem
${indent}                      key={item.id}
${indent}                      value={displayName}
${indent}                      onSelect={() => {
${defaultValueFromHandlerContent}${indent}                        formField.onChange(String(item.id))
${indent}                        set${toPascalCase}Open(false)
${indent}                      }}
${indent}                    >
${indent}                      <Check className={cn("size-4", {
${indent}                        "opacity-100": formField.value === String(item.id),
${indent}                        "opacity-0": formField.value !== String(item.id)
${indent}                      })} />
${indent}                      <span className="flex min-w-0 flex-col text-left">
${indent}                        <span className="truncate">{displayName}</span>
${indent}                        {secondaryDisplayName ? (
${indent}                          <span className="truncate text-xs text-muted-foreground">{secondaryDisplayName}</span>
${indent}                        ) : null}
${indent}                      </span>
${indent}                    </CommandItem>
${indent}                  )
${indent}                })}
${indent}              </CommandGroup>
${indent}            </CommandList>
${indent}          </Command>
${indent}        </PopoverContent>
${indent}      </Popover>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
